import jsPDF from "jspdf";

export function downloadWaybillPDF(ride) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  let y = 50;

  // Header
  doc.setFillColor(12, 13, 16); doc.rect(0, 0, W, 90, "F");
  doc.setTextColor(245, 178, 1); doc.setFontSize(22); doc.setFont("helvetica", "bold");
  doc.text("BULLER TAXI SERVICES", 40, 45);
  doc.setFontSize(9); doc.setTextColor(180);
  doc.text("Weatherford, Oklahoma · Driver Dispatch", 40, 62);
  doc.setTextColor(245, 178, 1);
  doc.setFontSize(10);
  doc.text(`WAYBILL #${ride.waybill_no || ride.id?.slice(0, 8)}`, W - 40, 45, { align: "right" });
  doc.setTextColor(255);
  doc.setFontSize(8);
  doc.text(new Date(ride.created_at || Date.now()).toLocaleString(), W - 40, 60, { align: "right" });

  y = 120;
  doc.setTextColor(20); doc.setFontSize(14); doc.setFont("helvetica", "bold");
  doc.text("Trip Information", 40, y); y += 22;
  doc.setFontSize(10); doc.setFont("helvetica", "normal");

  const row = (k, v) => { doc.setTextColor(120); doc.text(String(k), 40, y); doc.setTextColor(20); doc.text(String(v ?? "—"), 200, y); y += 16; };
  row("Ride Type:", (ride.ride_type || "").toUpperCase());
  row("Origin:", ride.origin);
  row("Destination:", ride.destination);
  row("Passengers:", ride.passengers);
  if (ride.driver_name) row("Driver:", ride.driver_name);
  if (ride.customer_name) row("Customer:", ride.customer_name);
  if (ride.customer_phone) row("Customer Phone:", ride.customer_phone);
  if (ride.notes) row("Notes:", ride.notes);

  y += 10;
  doc.setFontSize(14); doc.setFont("helvetica", "bold"); doc.text("Payment Information", 40, y); y += 22;
  doc.setFontSize(10); doc.setFont("helvetica", "normal");
  row("Method:", (ride.payment_method || "").toUpperCase().replace("CASHAPP", "CASH APP PAY"));
  if (ride.cashapp_tag) row("Cash App:", ride.cashapp_tag);
  if (ride.card_snapshot?.last4) row("Card:", `${(ride.card_snapshot.brand || "CARD").toUpperCase()} •••• ${ride.card_snapshot.last4}`);
  row("Quoted Fare:", `$${Number(ride.quoted_fare || 0).toFixed(2)}`);
  if (ride.tip_amount) row("Tip:", `$${Number(ride.tip_amount).toFixed(2)} ${ride.tip_pct ? `(${ride.tip_pct}%)` : ""}`);
  if (ride.payment_status) row("Payment Status:", ride.payment_status);
  if (ride.stripe_intent_id) row("Stripe Intent:", ride.stripe_intent_id);

  // Receipt totals
  y += 10;
  doc.setDrawColor(245, 178, 1); doc.setLineWidth(2); doc.line(40, y, W - 40, y); y += 18;
  doc.setFontSize(11); doc.setFont("helvetica", "normal");

  const bd = ride.breakdown || {};
  const fareTotalRow = (k, v) => {
    doc.setTextColor(120); doc.text(String(k), 40, y);
    doc.setTextColor(20); doc.text(String(v ?? "—"), W - 40, y, { align: "right" }); y += 14;
  };
  if (bd.local_franchise_fee > 0) fareTotalRow("Local Franchise Fee", `$${Number(bd.local_franchise_fee).toFixed(2)}`);
  // v2.6.5: rename "Maintenance Fee" → "Technology Fee" (BISON AI per-passenger fee).
  // Backward-compatible: legacy maintenance_fee key still rendered with the new label.
  const techFee = Number(bd.tech_fee || bd.maintenance_fee || 0);
  if (techFee > 0) {
    const paxN = bd.tech_fee_passengers || ride.passengers || 1;
    fareTotalRow(`Technology Fee (${paxN} pax)`, `$${techFee.toFixed(2)}`);
  }
  if (bd.sales_tax > 0) fareTotalRow(`Sales Tax (${bd.sales_tax_pct ?? ""}%)`, `$${Number(bd.sales_tax).toFixed(2)}`);
  if (bd.federal_tax > 0) fareTotalRow(`Federal Tax (${bd.federal_tax_pct ?? ""}%)`, `$${Number(bd.federal_tax).toFixed(2)}`);
  if (bd.state_tax > 0) fareTotalRow(`State Tax (${bd.state_tax_pct ?? ""}%)`, `$${Number(bd.state_tax).toFixed(2)}`);
  if (bd.city_tax > 0) fareTotalRow(`City Tax (${bd.city_tax_pct ?? ""}%)`, `$${Number(bd.city_tax).toFixed(2)}`);
  if (bd.geofence_applied) fareTotalRow("Weatherford Geofence Base", `$${Number(bd.geofence_flat_base ?? 0).toFixed(2)}`);

  doc.setFontSize(12); doc.setFont("helvetica", "bold");
  doc.setTextColor(120); doc.text("Subtotal", 40, y);
  doc.setTextColor(20); doc.text(`$${Number(ride.quoted_fare || ride.subtotal || 0).toFixed(2)}`, W - 40, y, { align: "right" }); y += 18;
  if (ride.tip_amount) {
    doc.setTextColor(120); doc.text("Tip", 40, y);
    doc.setTextColor(20); doc.text(`$${Number(ride.tip_amount).toFixed(2)}`, W - 40, y, { align: "right" }); y += 18;
  }
  doc.setFontSize(16); doc.setFont("helvetica", "bold");
  doc.setTextColor(245, 178, 1); doc.text("TOTAL", 40, y);
  doc.text(`$${Number(ride.total || 0).toFixed(2)}`, W - 40, y, { align: "right" });

  y += 40;
  doc.setFontSize(8); doc.setTextColor(120); doc.setFont("helvetica", "italic");
  doc.text("Acknowledgements:", 40, y); y += 12;
  doc.text("• All dues must be paid before leaving the starting destination.", 50, y); y += 12;
  doc.text("• Additional stops may incur additional fees.", 50, y); y += 12;
  doc.text("• Trips are subject to audio and video recording for safety.", 50, y); y += 24;
  doc.setTextColor(160); doc.setFont("helvetica", "normal");
  doc.text(`© ${new Date().getFullYear()} Bison AI · Buller Taxi Services. All Rights Reserved.`, W / 2, y, { align: "center" });

  doc.save(`waybill-${ride.waybill_no || ride.id?.slice(0, 8) || "trip"}.pdf`);
}
